import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a307431e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./assets/main.css?vue&type=style&index=0&id=a307431e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a307431e",
  null
  
)

export default component.exports